// extracted by mini-css-extract-plugin
module.exports = {"container":"_025a50318d--container--gTp8e","container-newbuilding":"_025a50318d--container-newbuilding--qoFWG","img":"_025a50318d--img--guBBR"};